// extracted by mini-css-extract-plugin
export default {"unread":"UnreadIndicator-module__unread--TzgM4"};